/**
 * Social Media Management service page
 * Converted blue-themed styling to orange brand styling
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { Globe, CheckCircle } from 'lucide-react'

export default function SocialMediaPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-orange-900 via-orange-800 to-orange-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">Social Media Management</h1>
              <p className="text-xl text-orange-100 leading-relaxed mb-8">
                Complete social media strategy, content planning, and community management to build 
                meaningful connections with your audience across all platforms.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Grow Your Social Presence</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/e2f44d23-be79-4beb-a458-f57433231626.jpg" 
                alt="Social Media Management"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Social Media Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive social media solutions to engage your audience and build brand loyalty
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="space-y-6">
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Strategy Development</h3>
                    <p className="text-gray-600">Custom social media strategies aligned with your business goals</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Content Creation & Scheduling</h3>
                    <p className="text-gray-600">Engaging posts, stories, and multimedia content with optimal timing</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Community Management</h3>
                    <p className="text-gray-600">Active engagement, response management, and community building</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Analytics & Reporting</h3>
                    <p className="text-gray-600">Detailed performance metrics and growth insights</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/d5a2049b-578e-4b53-a79f-3e50db45f7c4.jpg" 
                alt="Social Media Content"
                className="w-full h-96 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-orange-900 to-orange-700 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Dominate Social Media?</h2>
          <p className="text-xl text-orange-100 mb-8">
            Let us help you build a strong social media presence that drives engagement and growth
          </p>
          <Button asChild size="lg" className="bg-white text-orange-700 hover:bg-orange-50 text-lg px-8">
            <Link to="/contact">Start Your Social Strategy</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
